import React from "react";
import { Link } from "react-router-dom";
import AEDPrice from "../AEDPrice/AEDPrice";
import "./ProductCard.css";

export default function ProductCard({ product }) {

  const productUrl = `/${product.category}/${product.subCategory}/${product.slug}`;

  return (
    <Link to={productUrl} className="product-card-link">
      <div className="product-card">
        <div className="product-image-wrapper">
          <img
            src={product.mainImage}
            alt={product.productName}
            className="product-image"
          />
        </div>

        <div className="product-info">
          {product.brand && <p className="product-brand">{product.brand}</p>}
          <h3 className="product-name">{product.productName}</h3>
          {/* <p className="product-price"><AEDPrice value={product.price} /></p> */}
        </div>
      </div>
    </Link>
  );
}
